import { call, put } from 'redux-saga/effects';
import { push } from 'redux-little-router';

import { confirmRSPDataFailure, confirmRSPSuccess } from '../redux/actions';
import { confirmRSP } from '../services/api';

export function* confirmQSASaga({ payload: { step, cardId, pdfLink } }) {
  const { isOk, data, error } = yield call(confirmRSP, { cardId, pdf: pdfLink });
  if (isOk && data) {
    yield put(confirmRSPSuccess({}));
    yield put(push({ query: { step } }, { persistQuery: true }));
  } else {
    yield put(confirmRSPDataFailure(error));
  }
}
